<template>
  <div>
    <div class="row mb-1">
      <div class="col-md-8">
        <h4 class="text-uppercase mt-1">{{lexicon.drop_settings}}</h4>
      </div>
      <div class="col-md-4 text-right">
      </div>
    </div>
    <section id="groups" v-if="authenticated">

      <div class="row">
        <div class="col-md-4 col-sm-6"> 
          <div class="card">
            <div class="card-content">
              <div class="card-body">
                <h4 class="card-title">{{lexicon.drop_auth_password}}</h4>
                <p class="card-text">
                 {{lexicon.drop_auth_preff_type}}
                </p>
                <div class="form-group mb-1">
                  <label>{{lexicon.drop_auth_type}}</label>
                  <select class="form-control" v-model="user.settings.password_type">
                    <option value="0">{{lexicon.drop_sms_once_pass}}</option>
                    <option value="3">{{lexicon.drop_static_pass}}</option>
                  </select>
                </div>
                <div v-if="user.settings.password_type == 3">
                  <div class="form-group mb-1">
                    <label>{{lexicon.drop_new_pass}}</label>
                    <input type="password" class="form-control" :class="{error:errors.password}"
                        minlength="4"
                        v-model="password" :placeholder="lexicon.drop_new_pass">
                  </div>
                  <div class="form-group mb-1">
                    <label>{{lexicon.drop_repeat_pass}}</label>
                    <input type="password" :class="{error:errors.check_password}"
                        class="form-control" minlength="4"
                        v-model="check_password" :placeholder="lexicon.drop_repeat_pass">
                  </div>
                </div>
                <p class="card-text my-2" v-if="user.settings.password_type != 3">
                  <small class="text-muted">
                   {{lexicon.drop_sms_pass_info}}
                  </small>
                </p>
                <button class="btn btn-primary btn-block" @click.prevent="updateAuth">
                  {{lexicon.drop_save}}
                </button>

              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-content">
              <div class="card-body">
                <h4 class="card-title">{{lexicon.drop_stat_title}}</h4>
                <p class="card-text">
                  {{lexicon.drop_period_title}}
                </p>
                <div class="form-group">
                  <label>{{lexicon.drop_period}}</label>
                  <select class="form-control" v-model="user.settings.stat_period">
                    <option value="week">{{lexicon.drop_7days}}</option>
                    <option value="week2">{{lexicon.drop_14days}}</option>
                    <option value="month">{{lexicon.drop_1month}}</option>
                    <option value="quarter">{{lexicon.drop_3months}}</option>
                    <option value="all">{{lexicon.drop_all_stock}}</option>
                  </select>
                </div>
                <p class="card-text mb-2">
                  <small class="text-muted">
                    {{lexicon.drop_stat_info}}
                  </small>
                </p>
                <button class="btn btn-primary btn-block"
                    @click="updateData('stat_period',user.settings.stat_period)">
                  {{lexicon.drop_save}}
                </button>

              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-content">
              <div class="card-body">
                <h4 class="card-title">{{lexicon.drop_api_token}}</h4>
                <p class="card-text">
                  {{lexicon.drop_api_token_info}}
                </p>
                <div class="form-group ">
                  <label>{{lexicon.drop_api_token}}</label>
                  <input type="text"
                      class="form-control" disabled
                      v-model="user.api_token">
                </div>

                <p class="card-text mb-2">
                  <small class="text-muted">
                    {{lexicon.drop_api_token_warn}}
                  </small>
                </p>
                <button class="btn btn-danger btn-block" @click="newToken">
                  {{lexicon.drop_create_new}}
                </button>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-content">
              <div class="card-body">
                <h4 class="card-title">{{lexicon.drop_preorder_st_title}}</h4>
                <div class="form-group">
                  <label>{{lexicon.drop_preorder_st_label}}</label>
                  <select class="form-control" v-model="user.settings.preorder">
                    <option value="0">{{lexicon.drop_preorder_st_v1}}</option>
                    <option value="1">{{lexicon.drop_preorder_st_v2}}</option>
                    <option value="2">{{lexicon.drop_preorder_st_v3}}</option>
                    <option value="3">{{lexicon.drop_preorder_st_v4}}</option>
                  </select>
                </div>
                  <p class="card-text mb-2">
                  <small class="text-muted">
                    {{lexicon.drop_preorder_st_info}}
                  </small>
                </p>

                 <button class="btn btn-primary btn-block"
                    @click="updateData('preorder',user.settings.preorder)">
                  {{lexicon.drop_save}}
                </button>
              </div>
            </div>
          </div>
          <div class="card-deck">


          </div>
        </div>
        <div class="col-md-8 col-sm-6">
          <div class="card">
            <div class="card-content">
              <div class="card-body">
                <h4 class="card-title mt-2 mb-25">
                  {{lexicon.drop_prices_title}}
                </h4>
                <p class="card-text">
                  {{lexicon.drop_prices_desc}}
                </p>
                <div class="card-columns  mt-2 ">
                  <div class="card mb-1" v-for="price in user.settings.prices" :key="price.name">
                    <div class="card-content border-0 rounded  ">
                      <div class="card-body py-0 pl-0">  <!-- !py-0 !pl-0-->

                        <div class="custom-control custom-switch custom-switch-success mr-2 mb-01">  <!--mb-1-->

                          <input type="checkbox" @change.passive="updateData(price.name,!price.active,'enabled')"
                              v-model="price.active" class="custom-control-input" :id="'switch_'+price.name">
                          <label class="custom-control-label" :for="'switch_'+price.name">
														<span class="switch-icon-left">
															<i class="feather icon-check"></i>
														</span>
                            <span class="switch-icon-right">
															<i class="feather icon-check"></i>
														</span>
                          </label>
                          <small class="d-inline-block ml-1 w-75">{{ price.title }}</small>
                        </div>
                        <div class="input-group " v-if="1===2">
                          <input @change.passive="updateData(price.name,price.value)"
                              v-model="price.value" type="number" class="form-control"
                              step="1" :disabled="!price.active"
                              :placeholder="price.title">
                          <div class="input-group-append">
                            <span class="input-group-text">{{lexicon.drop_uah_sign}}</span>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

import axios from "axios";
import {mapGetters, mapState} from 'vuex'
import store from "@/store";
import toast from "../helpers/toast";

export default {
  name: 'settings',
  computed: {
    ...mapGetters({
      user: 'auth/user',
      authenticated: 'auth/authenticated',
    }),
    ...mapState({
      lexicon: 'lexicon',
    })
  },
  data() {
    return {
      loading: true,
      password: '',
      check_password: '',
      test: {},
      errors: {},
    }
  },
  created() {
    store.dispatch('auth/attempt', localStorage.getItem('token'))
    this.api_token = this.user.api_token;
  },
  methods: {
    fetchData(data) {
      this.loading = true
      this.test = data
      axios.post('settings/', data).then((response) => {
        if (typeof (response.data.data.api_token) !== "undefined") {
          store.dispatch('auth/api_token', response.data.data.api_token)
        }
        this.loading = false
      })
    },
    updateAuth() {
      this.errors = {}
      if (this.user.settings.password_type != 3) {
        this.fetchData({'param': 'auth', 'value': this.user.settings.password_type})
      } else {
        if (this.password !== this.check_password) {
          this.errors.password = 1
          this.errors.check_password = 1
          toast.error(this.lexicon.drop_password_not_match, this.lexicon.drop_error)
        } else {
          if (this.password.length > 3) {
            this.fetchData({
              'param': 'auth',
              'value': this.user.settings.password_type,
              'password': this.password
            })
          } else {
            this.errors.password = 1
            this.errors.check_password = 1
            toast.error(this.lexicon.drop_min_length, this.lexicon.drop_error)
          }
        }
      }
    },
    newToken() {
      this.fetchData({'param': 'token'})
    },
    updateData(key, val, type) {
      if (val !== '') {
        this.fetchData({'param': key, 'value': val, 'type': type})
      }

    }
  }
}
</script>
